import { useDashboard } from "./DashboardContext.js";

export function useSettings() {
  const { data } = useDashboard();
  return {
    quickAddFields: data?.settings?.quickAddFields ?? [],
    declutterMonths: data?.settings?.declutterMonths ?? 6,
    declutterSeasonalMonths: data?.settings?.declutterSeasonalMonths ?? 12,
  };
}
